import { IonicVue } from '@ionic/vue'
import { createPinia } from 'pinia'
import PortalVue from 'portal-vue'
import VCalendar from 'v-calendar'
import { createApp } from 'vue'
import '@/style.css'
import App from '@/App.vue'
import BaseLayout from '@/components/BaseLayout.vue'
import {
  i18n,
  loadLanguageAsync,
} from '@/modules/i18n'
import router from '@/router'

// import 'uno.css'

/* Core CSS required for Ionic components to work properly */
import '@ionic/vue/css/core.css'

/* Basic CSS for apps built with Ionic */
import '@ionic/vue/css/normalize.css'
import '@ionic/vue/css/structure.css'
import '@ionic/vue/css/typography.css'

import '@/assets/css/theme.css'
import '@/assets/css/index.css'
import '@/assets/css/transitions.css'
import 'v-calendar/style.css'

const pinia = createPinia()

const app = createApp(App)
  .use(IonicVue)
  .use(i18n)
  .use(router)
  .use(pinia)
  .use(PortalVue)
  .use(VCalendar)

app.component('BaseLayout', BaseLayout)

// Inicializar el cliente HTTP antes de montar la aplicación
const initializeApp = async () => {
  try {
    // Montar la aplicación
    await router.isReady()
    app.mount('#app')

    // Cargar el idioma
    await loadLanguageAsync('en')

    // Registrar el Service Worker
    if ('serviceWorker' in navigator) {
      window.addEventListener('load', async () => {
        try {
          const registration = await navigator.serviceWorker.register('/firebase-messaging-sw.js', {
            scope: '/'
          });

          console.log('Service Worker registrado correctamente:', registration);

          registration.addEventListener('updatefound', () => {
            const newWorker = registration.installing;
            if (newWorker) {
              newWorker.addEventListener('statechange', () => {
                if (newWorker.state === 'installed' && navigator.serviceWorker.controller) {
                  console.log('Nueva versión del Service Worker disponible');
                }
              });
            }
          });

          registration.addEventListener('error', (error) => {
            console.error('Error en el Service Worker:', error);
          });

          if (registration.active) {
            console.log('Service Worker activo y listo');
          }

        } catch (error) {
          console.error('Error registrando Service Worker:', error);
        }
      });
    }
  } catch (error) {
    console.error('Error inicializando la aplicación:', error);
  }
}

initializeApp();

